import { gql } from "@apollo/client";

const PARLORS = gql`
  query PARLORS($where: core_parlor_bool_exp = {}) {
    parlors: core_parlor(where: $where, order_by: { name: asc }) {
      id
      name
      maps: google_maps_url
      is_grant
    }
  }
`;

const PARLOR_COUCHES = gql`
  query PARLOR_COUCHES($where: core_parlorcouch_bool_exp) {
    couches: core_parlorcouch(where: $where) {
      id
      parlor: parlor_id
      name
      photo
      for_rent
      days_for_rentals
      couch_price: core_couchprice {
        id
        name
        type
        price
      }
    }
  }
`;

export { PARLORS, PARLOR_COUCHES };
